import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { CloseIcon } from '../../../assets';
import { handleRowClassForEngagementsTable } from '../../../utility';

const CombineData = ({
    handleClose, data, showAssets 
}) => {
    const rowCount = data.channels_engaged.length;

    return (
        <Box className="custom-modal-inner-container-center background-#FFFFFF">
            <Grid container className="padding-tb-24-rl-16 sticky_modal_header border-1-gray">
                <Grid item className="flex-row-space-between-center" xs={12}>
                    <Box className="icon" onClick={() => handleClose(null)}>
                        <CloseIcon color="#98A2B3" height="12" width="12" />
                    </Box>
                </Grid>
            </Grid>

            <TableContainer className='no-box-shadow no-border' component={Paper}>
                <Table className='table-border-collapse no-border'>
                    <TableHead>
                        <TableRow>
                            <TableCell className="table-headers-title">Channel</TableCell>
                            <TableCell className="table-headers-title">Vendor</TableCell>
                            {showAssets ? <TableCell className="table-headers-title">Assets</TableCell> : null}
                            <TableCell className="table-headers-title">Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {[...Array(rowCount)].map((_, i) => (
                            <TableRow className={handleRowClassForEngagementsTable(i, 0)} key={i}>
                                <TableCell className='table-row-data no-border'>{data.channels_engaged[i]}</TableCell>
                                <TableCell className='table-row-data no-border'>{data.vendor_engaged[i]}</TableCell>
                                {showAssets ? <TableCell className='table-row-data no-border'>{data.assets[i]}</TableCell> : null}
                                <TableCell className='table-row-data no-border'>{data.channels_engaged_date[i]}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </Box>
    );
};

CombineData.propTypes = {
    handleClose: PropTypes.func,
    showAssets: PropTypes.bool,
    data: PropTypes.shape({
        channels_engaged: PropTypes.array.isRequired,
        vendor_engaged: PropTypes.array.isRequired,
        assets: PropTypes.array.isRequired,
        channels_engaged_date: PropTypes.array.isRequired
    }).isRequired
};

export default CombineData;
